export type Environment = 'production' | 'development' | 'local'

// prettier-ignore
const LOCAL_HOSTNAME_PATTERNS = [
    /^localhost$/,
    /^0\.0\.0\.0$/,
    /^127\.0\.0\.1$/,
    /.*\.trycloudflare\.com$/,
]

// prettier-ignore
const DEV_PATTERNS = [
    /^.+\.medendo\.dev$/,
]

export function getEnvironment(): Environment {
    const hostname = window.location.hostname.toLowerCase()

    if (LOCAL_HOSTNAME_PATTERNS.some((pattern) => pattern.test(hostname))) {
        return 'local'
    }

    if (DEV_PATTERNS.some((pattern) => pattern.test(hostname))) {
        return 'development'
    }

    return 'production'
}
